import type { ActionHandler } from '../types'

export const handleOpenSkill: ActionHandler<'OPEN_SKILL'> = async (ctx, payload) => {
  const row = {
    character_id: ctx.characterId,
    skill_name: payload.skill_name,
    sb: payload.sb,
    ml: payload.oml,
    oml: payload.oml,
    max_ml: payload.max_ml,
    source: 'training',
    is_automatic: false,
  }

  const { data, error } = await ctx.supabase
    .from('character_skills')
    .insert(row)
    .select()
    .single()

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'character_skills',
      target_row_id: data.id,
      target_field: '*',
      operation: 'INSERT' as const,
      old_value: null,
      new_value: data,
    }],
    label: `Open skill: ${payload.skill_name} at ML ${payload.oml}`,
  }
}
